import { existGuestUser } from "src/utils/TokenTools";
import { UserCookies, UserProfile } from "../model/state/partials/profile.model";


export const mockUserProfile: UserProfile = {
  firstName: "user",
  lastName: "user-last-name",
  logonId: "user@mock.com|ZARA_FR",
  email: "user@mock.com",
  verificationData: {
    verified: false,
    hasToBeVerified: "OPTIONAL",
    verificationDetails: {
      verifiedPhone: {
        verified: false
      },
      verifiedEmail: {
        verified: false
      }
    }
  },
};

export const mockUserCookies: UserCookies = {
  user_id: "1234567890",
  user_type: "registered",
};